import React, { ReactNode, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import socketService from "./services/socketService";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import { store, persistor } from "./core/data/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider, useSelector } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import "./core/common/dataTable/customAntdTable.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer } from "react-toastify";
import MotivationPopup from "../src/core/modals/MotivationPopup";
import MoodPopup from "./feature-module/application/MoodMeter/MoodPopup";
import LeadRemindersPopup from "./feature-module/application/LeadReminders/LeadRemindersPopup";
import CallSessionProvider from "./feature-module/crm/liveCall/components/CallSessionProvider";
import GlobalCallOverlay from "./feature-module/crm/liveCall/components/GlobalCallOverlay";
import AutoCallNavBlocker from "./feature-module/crm/liveCall/components/AutoCallNavBlocker";
import GlobalCallWidget from "./feature-module/application/GlobalCallWidget";
import GlobalMessagePopup from "./feature-module/application/GlobalMessagePopup";
import { GlobalCallProvider } from "./feature-module/application/GlobalCallContext";
// import GlobalCallProvider from "./feature-module/application/GlobalCallContext";

interface SocketWrapperProps {
  children: ReactNode;
}

const SocketWrapper: React.FC<SocketWrapperProps> = ({ children }) => {
  const user = useSelector((state: any) => state.user?.user);

  useEffect(() => {
    if (user?.userDetails?.id) {
      socketService.initialize(user.userDetails.uid);
      localStorage.setItem("userId", user.userDetails.uid);
    }
    return () => {
      socketService.disconnect();
    };
  }, [user]);

  return <>{children}</>;
};

const AppContent: React.FC = () => {
  const user = useSelector((state: any) => state.user?.user);

  const hasMoodMeterAccess = React.useMemo(() => {
    if (!user?.userDetails?.permissions) return false;
    const moodMeterModule = user.userDetails.permissions.find(
      (perm: any) => perm.name === "Mood Meter"
    );
    return moodMeterModule && moodMeterModule.permissions?.length > 0;
  }, [user]);

  const hasLeadRemindersAccess = React.useMemo(() => {
    const isGranted = (nodes: any): boolean => {
      if (!Array.isArray(nodes)) return false;
      return nodes.some((n: any) => {
        const perms = n?.permissions;
        if (
          n?.name === "Lead Reminders" &&
          Array.isArray(perms) &&
          perms.length > 0
        ) {
          return true;
        }
        if (Array.isArray(perms) && perms.length > 0 && typeof perms[0] === "object") {
          return isGranted(perms);
        }
        return false;
      });
    };
    return isGranted(user?.userDetails?.permissions);
  }, [user]);

  return (
    <>
      <ALLRoutes />
      <MotivationPopup />
      {hasMoodMeterAccess && <MoodPopup />}
      {hasLeadRemindersAccess && <LeadRemindersPopup />}
    </>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <ToastContainer />
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename={base_path}>
        <SocketWrapper>
          <GlobalCallProvider>
            <CallSessionProvider>
              <AppContent />
              <GlobalCallOverlay />
              <AutoCallNavBlocker />
            </CallSessionProvider>

            <GlobalCallWidget />
            <GlobalMessagePopup />
          </GlobalCallProvider>
        </SocketWrapper>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
